import React from 'react';
import { debounce } from 'lodash';
import Panel from '../../../../components/outline/Panel';
import BaseForm from '../../../../components/form/BaseForm';
import InputForm from '../../../../components/form/InputForm';
import SelectForm from '../../../../components/form/SelectForm';
import { INVALID_RELATED_KEYWORD_MAXIMUM_MESSAGE } from '../../../../constants/service/invalidMsg/SearchWordInvalidMsg';
import { MAXIMUM_NUMBER_OF_RELATED_KEYWORD_LIST } from '../../../../constants/service/app/searchWordConstants';
import { formRequiredRules } from '../../../../lib/formRules';
import './SearchWordSaveInfo.scss';

const SearchWordSaveInfo = (props) => {
  const { form, searchWordSave, setData, isEdit, checkKeyword, getRelatedSearchWordList } = props;
  const { word, count, isDuplicateWord, relatedKeywordList, relatedKeywordSelectList } = searchWordSave;

  return (
    <Panel className="search-word-save-info">
      <div className="panel-header">
        <div className="title">검색 키워드 정보</div>
      </div>

      <div className="panel-body">
        {/* 키워드 */}
        <InputForm
          form={form}
          label="키워드"
          name="keyword"
          rules={[formRequiredRules(true, undefined, false)]}
          initialValue={word}
          onChange={(value) =>
            setData({
              path: ['word'],
              value,
            })
          }
          onKeyUp={debounce(
            () =>
              checkKeyword({
                word,
              }),
            200,
          )}
          size="large"
          disabled={isEdit}
          subContent={isDuplicateWord ? <p className="input-warning">이미 존재하는 검색 키워드입니다.</p> : null}
        />

        {/* 키워드 */}
        {isEdit ? <BaseForm label="검색 누적 횟수" content={count} /> : null}

        {/* 연관 키워드 */}
        <BaseForm
          label={
            <div className="count-of-total">
              연관 키워드 (<span> {relatedKeywordList.idList ? relatedKeywordList.idList.length : 0} </span>/
              {MAXIMUM_NUMBER_OF_RELATED_KEYWORD_LIST})
            </div>
          }
          content={
            <SelectForm
              form={form}
              name="related-keyword"
              mode="multiple"
              rules={[
                {
                  validator: (rule, value, cb) => {
                    if (value.length > MAXIMUM_NUMBER_OF_RELATED_KEYWORD_LIST) {
                      cb(INVALID_RELATED_KEYWORD_MAXIMUM_MESSAGE);
                    } else cb();
                  },
                },
              ]}
              isTable
              showSearch
              filterOption={false}
              list={relatedKeywordSelectList}
              initialValue={relatedKeywordList.idList}
              onChange={(list) =>
                setData({
                  path: ['relatedKeywordList', 'idList'],
                  value: list,
                })
              }
              onSelect={(id) => {
                const keywordName = relatedKeywordSelectList.find((item) => item.id === id).name;

                setData({
                  path: ['relatedKeywordList', 'nameList'],
                  value: [...relatedKeywordList.nameList, keywordName],
                });
              }}
              onDeselect={(id) => {
                const keywordName = relatedKeywordSelectList.find((item) => item.id === id).name;
                const filteredRelatedKeywordNameList = relatedKeywordList.nameList.filter(
                  (name) => name !== keywordName,
                );

                setData({
                  path: ['relatedKeywordList', 'nameList'],
                  value: filteredRelatedKeywordNameList,
                });
              }}
              onSearch={(word) =>
                getRelatedSearchWordList({
                  word,
                })
              }
            />
          }
        />
      </div>
    </Panel>
  );
};

export default SearchWordSaveInfo;
